import { Button, Card, Col, Form, Input, Row, Typography } from "antd";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const Register = () => {
  const [loader, setLoader] = useState(false);
  const { Title } = Typography;
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      setLoader(true);

      // Send registration data to backend
      const resp = await axios.post("https://rhrmapi.up2dateinc.com/api/auth/register", values);

      if (resp.data) {
        toast.success(resp.data.message || "Registration Successful");

        // Navigate to login page
        navigate("/admin/auth/login");

        form.resetFields();
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "Registration failed");
    } finally {
      setLoader(false);
    }
  };

  return (
    <Row className="mr-top">
      <Col span={12} offset={6}>
        <Card bordered={false} className="criclebox h-full">
          <Title level={3} className="m-3 text-center">
            Register
          </Title>

          <Form
            form={form}
            className="m-4"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 16 }}
            onFinish={onFinish}
            autoComplete="off"
          >
            <Form.Item
              label="First Name"
              name="firstName"
              rules={[{ required: true, message: "Please input first name!" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Last Name"
              name="lastName"
              rules={[{ required: true, message: "Please input last name!" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="User Name"
              name="userName"
              rules={[{ required: true, message: "Please input username!" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: "Please input email!" },
                { type: "email", message: "Enter valid email!" },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true, message: "Please input password!" }]}
            >
              <Input.Password />
            </Form.Item>

            <Form.Item
              wrapperCol={{
                offset: 6,
                span: 16,
              }}
            >
              <Button
                block
                type="primary"
                htmlType="submit"
                shape="round"
                loading={loader}
              >
                Register
              </Button>
            </Form.Item>

            <h6 className="text-center mt-2">
              Already have an account? <Link to="/admin/auth/login">Login Here</Link>
            </h6>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};

export default Register;